<div>
<!--  <div [formGroupName]="myFormGroupName">-->
    <!--    <div formArrayName="transferors">-->
    <!--      <div class="ap-form-field-my-wrapper" *ngFor="let transferor of transferors.controls; let i = index;">-->
    <!--        <ap-form-field [label]="'Please specify the LEID of the Transferor'" [id]="i.toString()" [type]="'input'"-->
    <!--                       [placeholder]="'Hint text'" [formControlName]="i">-->
    <!--        </ap-form-field>-->
    <!--        <ap-button class="btn-plus-minus" *ngIf="selectedOptionID === 2" [btnType]="'secondary'"-->
    <!--                   [config]="{isFloating: true}" [btnSize]="'small'" (onBtnClick)="addTransferor()">-->
    <!--          <span class="Appkit4-icon a-btn-icon icon-plus-fill"></span>-->
    <!--        </ap-button>-->
    <!--        <ap-button class="btn-plus-minus" *ngIf="selectedOptionID === 2 && i > 0" [btnType]="'secondary'"-->
    <!--                   [config]="{isFloating: true}" [btnSize]="'small'" (onBtnClick)="removeTransferorAt(i)">-->
    <!--          <span class="Appkit4-icon a-btn-icon icon-minus-fill"></span>-->
    <!--        </ap-button>-->
    <!--      </div>-->
    <!--      <div class="transferor-details">-->
    <!--        &lt;!&ndash;              <span>Name of Transferor:</span><span>{{transferor.transferorName}}</span>&ndash;&gt;-->
    <!--      </div>-->
    <!--      <div class="transferor-details">-->
    <!--        &lt;!&ndash;              <span>EIN:</span><span>{{transferor.transferorEIN}}</span>&ndash;&gt;-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="form-field-wrapper">
      @if (label !== '') {
<label [for]="labelId">{{label}}</label>
}
      <div class="search-dropdown-wrapper">
        <input type="text" class="search-dropdown-input" [ngModel]="selectedLEID" [id]="labelId"
               (keyup)="onKeyUpSearch($event)" maxlength="6">
        @if (loading) {
<div class="search-dropdown-loader">
          <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
        </div>
}
        @if (selectedLEID) {
<div class="search-dropdown-clear">
          <span class="Appkit4-icon icon-close-outline" title="Clear" (click)="clearEntity()"></span>
        </div>
}
        @if (showDropdownMenu) {
<div class="search-dropdown-menu" dstClickOutside (clickOutside)="onClickOutside()">
          @for (detail of entityDetailsList; track $index) {
<span class="entity-list-item" (click)="selectEntity(detail)">{{detail.LEID}}-{{detail.ENTITY}}</span>
}
        </div>
}
      </div>
    </div>
    <!--    <div class="ap-form-field-my-wrapper">-->
    <!--      <ap-form-field [label]="'Please specify the LEID of the Transferee'" [id]="'100'" [type]="'input'" [placeholder]="'Hint text'"-->
    <!--                     formControlName="transferee" required>-->
    <!--      </ap-form-field>-->
    <!--    </div>-->
<!--    <div class="entity-details">-->
<!--      <span>Name of Transferee:</span><span>{{transfereeName}}</span>-->
<!--    </div>-->
<!--    <div class="entity-details">-->
<!--      <span>EIN:</span><span>{{transfereeEIN}}</span>-->
<!--    </div>-->
<!--  </div>-->
</div>
